class FavMarquee extends HTMLElement {
    // TODO start marquee after all styles are loaded
  constructor() {
    super();
    this.items = this.querySelectorAll('.item');
    this.wrapper = this.querySelector('.wrapper');
    if(this.items.length == 0) {
        return
    }
    
    document.addEventListener('DOMContentLoaded', this.initialize.bind(this))
  }
  
  initialize() {
    
    this.width = 0
    this.items.forEach((item)=>{
        this.width += item.offsetWidth
    })

    let itemMultiplicator = this.dataset.itemMultiplicator

    for(let i = 0; i < itemMultiplicator; i++) {
        this.items.forEach((item)=>{
            const clone = item.cloneNode(true)
            this.wrapper.appendChild(clone)
        })
    }
    this.wrapper.style.setProperty('--animation-width', '-' + this.width + 'px');
    this.factor = this.width / 300
    this.speed = this.dataset.speed * this.factor;
    this.wrapper.style.animationDuration = this.speed + 's'
    this.classList.add('active')
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('fav-marquee', FavMarquee);
